import { useSelector } from 'react-redux'

import {
  LoginButton,
  VerifyEmailButton,
  CommentForm,
} from 'ui-component-library/components/CommentsModule'
import {
  getIsLoggedIn,
  getIsEmailVerified,
  getUserName,
} from 'store/user/selectors'
import { getCommentStrings } from 'store/strings/selectors'

type Props = {
  onSubmit: (text: string) => Promise<void>
  buttonText: string
  onClose: () => void
  placeholderText?: string
}

function CommentFormContainer({
  placeholderText,
  buttonText,
  onSubmit,
  onClose,
}: Props) {
  const { loginCommentText, verifyLink, closeFormLabelText } = useSelector(
    getCommentStrings,
  )
  const isEmailVerified = useSelector(getIsEmailVerified)
  const isLoggedIn = useSelector(getIsLoggedIn)
  const userName = useSelector(getUserName)

  if (!isLoggedIn) {
    return <LoginButton>{loginCommentText}</LoginButton>
  }

  if (!isEmailVerified) {
    return (
      <VerifyEmailButton url={verifyLink.url}>
        {verifyLink.text}
      </VerifyEmailButton>
    )
  }

  return (
    <CommentForm
      buttonText={buttonText}
      placeholderText={placeholderText}
      closeFormLabelText={closeFormLabelText}
      onClose={onClose}
      onSubmit={onSubmit}
      userName={userName}
    />
  )
}

export default CommentFormContainer
